import gql from "graphql-tag";

export const catalogCategoryQuery = gql`
  query catalogCategory($categoryId: ID!) {
    catalogCategory(id: $categoryId) {
      id
      name
      sort
      isActive
      parentId
      forNotice
      createdAt
      linkedProductCategoryIds
    }
  }
`;

export const productCategoriesQuery = gql`
  query productCategories {
    productCategories {
      id
      description
      parent
      children
      catalogCategoryId
    }
  }
`;
